import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ATTACHMENT_SLIDE_PAGE_TYPE_CATEGORY, ATTACHMENT_SLIDE_PAGE_TYPE_IMAGE, ATTACHMENT_SLIDE_PAGE_DATA_TYPE_NO_CATEGORY, } from '../../../../define/consts/slide_types';
/**
 * category.slideTypesを整形して返すuse
 * @returns {{images, categories}}
 */
export const useSlideSearchSlideTypeValues = () => {
    const rawSlideTypes = useSelector((state) => state.category.slideTypes);
    const { categories, images } = useMemo(() => {
        const types = rawSlideTypes || [];
        const filterByCategoryType = (categoryType) => types.filter((v) => v.categoryType === categoryType &&
            v.dataType !== ATTACHMENT_SLIDE_PAGE_DATA_TYPE_NO_CATEGORY);
        return {
            categories: filterByCategoryType(ATTACHMENT_SLIDE_PAGE_TYPE_CATEGORY),
            images: filterByCategoryType(ATTACHMENT_SLIDE_PAGE_TYPE_IMAGE),
        };
    }, [rawSlideTypes]);
    return {
        categories,
        images,
    };
};
export const useSlideSearchCommonSlideType = {
    useSlideSearchSlideTypeValues,
};
